export default __webpack_public_path__ + "static/nrg-logo-h100px-gray-d0d440333ce978c15f2c9f5710ec3df9.png";